module.exports = __webpack_public_path__ + "img/nf.82cb457.svg";